import React from "react";
import "../styles/Termsofuse.css";


const DriverRequirements = () => {
  return (
    <div className="legal-wrapperss">
      <main className="legal-main">
        <h2>Driver Requirements</h2>
        <p className="intro-paragraph">
          At BERYMO, Inc., our top priority is the safety and security of our
          riders and the communities we serve. To maintain a trustworthy and
          reliable platform, all drivers must meet the following
          requirements. These standards are essential for ensuring a professional
          and safe experience for everyone on the BERYMO platform.
        </p>
        <hr />

        <h3>1. Driver's License</h3>
        <p>
          To operate with BERYMO, Inc., you must possess a valid driver's license issued by the state or jurisdiction in which you intend to provide transportation services. The license must be current and not suspended, revoked, or expired.
        </p>
        <p>
          <strong>
            You are required to upload a clear, legible photo of your driver's
            license through the BERYMO DRIVER mobile application. The uploaded
            image must show all details, including your name, date of birth,
            license number, issue date, and expiration date.
          </strong>
        </p>
        <p>
          BERYMO, Inc. reserves the right to verify the authenticity of the
          driver's license with the relevant authorities. Failure to provide a
          valid driver's license will result in the inability to receive Ride
          Opportunities.
        </p>
        <hr />

        <h3>2. Vehicle Insurance</h3>
        <p>
          All drivers must maintain valid vehicle insurance that meets or exceeds
          the minimum requirements set by the state or jurisdiction in which they
          operate. The insurance policy must cover the vehicle used for performing
          Contracted Services and include liability coverage for bodily injury and
          property damage.
        </p>
        <p>
          <strong>
            You are required to upload a copy of your current vehicle insurance
            policy or insurance card through the BERYMO DRIVER mobile application.
            The document must clearly display the policyholder's name, vehicle
            details (make, model, year, and VIN), coverage amounts, and policy
            effective and expiration dates.
          </strong>
        </p>
        <p>
          Drivers must promptly update their insurance information in the BERYMO
          DRIVER mobile application whenever a policy is renewed or changed.
          Failure to maintain valid insurance or provide updated documentation will
          result in deactivation from the platform.
        </p>
        <hr />

        <h3>3. Vehicle Inspection</h3>
        <p>
          The vehicle used for Contracted Services must pass a vehicle inspection
          conducted by a licensed mechanic or authorized inspection facility in
          accordance with local regulations. The inspection ensures that the
          vehicle is safe, roadworthy, and compliant with all applicable laws.
        </p>
        <p>
          <strong>
            You must upload a photo or scanned copy of the vehicle inspection
            report through the BERYMO DRIVER mobile application. The report must
            include the inspection date, vehicle details (make, model, year, and
            VIN), and confirmation that the vehicle passed the inspection.
          </strong>
        </p>
        <p>
          Vehicles must be re-inspected as required by local laws or at BERYMO,
          Inc.'s discretion. Failure to provide a valid inspection report will
          prevent you from receiving Ride Opportunities.
        </p>
        <hr />

        <h3>4. Profile Photo</h3>
        <p>
          To ensure trust and safety for riders, all drivers must provide a clear
          and recent profile photo for identification purposes. The photo will be
          visible to riders through the BERYMO or BERYMO PLACES mobile
          applications.
        </p>
        <p>
          <strong>
            You are required to upload a professional-quality headshot through the
            BERYMO DRIVER mobile application. The photo must clearly show your
            face, be well-lit, and taken against a plain background. Photos that
            are blurry, low-quality, or include other individuals or objects will
            not be accepted.
          </strong>
        </p>
        <p>
          BERYMO, Inc. reserves the right to reject profile photos that do not meet
          these standards. Drivers must update their profile photo if requested by
          BERYMO, Inc. to ensure it remains current.
        </p>
        <hr />

        <h3>5. Background Check and Criminal History</h3>
        <p>
          To maintain a safe environment for riders and partners, all drivers must
          undergo a background check conducted by BERYMO, Inc. or a third-party
          provider. The background check will review your criminal history and
          driving record to ensure compliance with BERYMO, Inc.'s safety
          standards.
        </p>
        <p>
          <strong>
            Drivers must have no pending criminal cases, convictions for violent
            crimes, sexual offenses, or driving-related offenses (such as DUI or
            reckless driving) within the past seven years, or as otherwise
            required by local law. Any driver with a criminal history that violates
            BERYMO, Inc.'s safety policies will be ineligible to provide Contracted
            Services.
          </strong>
        </p>
        <p>
          You must consent to the background check process through the BERYMO
          DRIVER mobile application and provide any necessary information, such as
          your full name, date of birth, and Social Security Number (or equivalent
          identification number). Failure to pass the background check or provide
          accurate information will result in deactivation from the platform.
        </p>
        <hr />

        <h3>6. Compliance with BERYMO Policies</h3>
        <p>
          In addition to the above requirements, drivers must comply with all
          BERYMO, Inc. policies, including but not limited to the Terms of Service,
          Community Guidelines, and Independent Contractor Agreement. Failure to
          meet these requirements or adhere to policies may result in temporary
          suspension or permanent deactivation from the BERYMO platform.
        </p>
        <p>
          <strong>
            BERYMO, Inc. reserves the right to request additional documentation or
            verification at any time to ensure ongoing compliance with these
            requirements.
          </strong>
        </p>
        <p>
          By submitting the required documents and consenting to the background
          check, you acknowledge that you have read, understood, and agree to
          comply with these Driver Requirements and all related policies.
        </p>

       
      </main>
    </div>
  );
};

export default DriverRequirements;